import { MEDIA_MIN_M } from '@/utils/mediaQuery';

export default {
  methods: {
    scrollIntoViewport() {
      const headerElem = document.getElementById('__header-inner');
      const headerTop = this.$el.getBoundingClientRect().top;
      let offsetTop = headerTop + window.scrollY;

      if (headerElem) {
        const hasStickyHeader = !(import.meta.client && window.matchMedia(MEDIA_MIN_M).matches);
        const headerHeight = headerElem && hasStickyHeader ? headerElem.offsetHeight : 0;
        offsetTop -= headerHeight;
      }

      window.scrollTo({
        behavior: 'smooth',
        top: offsetTop,
      });
    },

    scrollToTop() {
      if (!import.meta.client || !window) {
        return;
      }

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },

    scrollTo(ref, { block = 'start', behavior = 'smooth' } = {}) {
      // if it's a Vue component, get the DOM element, otherwise assume it's a DOM element
      const element = this.$refs[ref]?.$el || this.$refs[ref];

      element?.scrollIntoView({
        block,
        behavior,
      });
    },

    scrollToMaybe(ref, { visibilityThreshold = 0.9, autoPosition = true } = {}) {
      const observer = new IntersectionObserver((entries) => {
        const firstEntry = entries?.[0];

        if (firstEntry && firstEntry.intersectionRatio <= visibilityThreshold) {
          const intersectingTop = firstEntry.boundingClientRect.y <= 0;

          this.scrollTo(ref, {
            block: !autoPosition || intersectingTop ? 'start' : 'end',
          });
        }

        observer.disconnect();
      });

      observer.observe(ref?.$el);
    },

    handleHashScrollTo() {
      if (!this.$route.hash) {
        return;
      }

      const ref = this.$refs[this.$route.hash.replace('#', '')];
      ref?.$el?.scrollIntoView({
        behavior: 'smooth',
      });
    },
  },
};
